import { RootRoutes, RoutesRoutes as Routes } from '../codegen';

function mountRoute(route: string, prefix: string = RootRoutes.HEALTH_INSURANCE_ROUTE): string {
  return `${prefix}${route}`;
}

export const BaseRoute = {
  LOGIN: '/login',
  INACTIVITY: '/inatividade',
  FORGOT_PASSWORD: '/forgot-password',
  HEALTH_DECLARATION: '/declaracao-saude/:hash',
  HEALTH_DECLARATION_VALID: '/declaracao-saude/:hash/valido',
  HEALTH_DECLARATION_DYNAMIC_FORM: '/declaracao-saude/:hash/form',
  HEALTH_DECLARATION_INVALID: RootRoutes.HEALTH_DECLARATION_INVALID_ROUTE,
  HEALTH_DECLARATION_FINALIZATION: RootRoutes.HEALTH_DECLARATION_FINALIZATION_ROUTE,
  HEALTH_DECLARATION_CANCELATION: RootRoutes.HEALTH_DECLARATION_CANCELATION_ROUTE,
};

export const APPLICATION_ROUTES = {
  ASSIGN_PRIVACY_WARNING: mountRoute(Routes.ROUTE_ASSIGN_PRIVACY_WARNING),
  ASSING_TERM_USE: mountRoute(Routes.ROUTE_ASSIGN_TERM_USE),
  MY_DATA: mountRoute(Routes.ROUTE_MY_DATA),
  PRIVACY: mountRoute(Routes.ROUTE_PRIVACY),
  TECHNICAL_VISIT: mountRoute(Routes.ROUTE_TECHNICAL_VISIT),
};

export const ROUTE = {
  TECHNICAL_VISIT_DETAILS: mountRoute(Routes.ROUTE_TECHNICAL_VISIT_DETAILS),
  TECHNICAL_VISIT_FORMS: mountRoute(Routes.ROUTE_TECHNICAL_VISIT_FORMS),
};
